import stores from 'cd-eft/models/Stores';
import * as PRJAPI from 'cd-eft/services/eftPrjAdminApi';

const { AppStore } = stores;

export async function saveNote(): Promise<void> {
  const { basicDataForm, projectsStore } = AppStore.efh2Store;

  const note = validateNote(basicDataForm.note);
  const postJson = {
    projectUuid: projectsStore.currentProject.projectUuid,
    userInputNotes: note,
    rdtSmoothing: basicDataForm.rdt_smoothing,
    duhName: basicDataForm.dimUnitHydrogID,
  };

  try {
    await PRJAPI.UserInputsController.updateUserInputsByProjectUuidUsingPOST(postJson);
  } catch (error) {
    console.error(error);
    throw new Error('Unexpected result on saveNote');
  }
}

export async function updateNote(): Promise<void> {
  const { basicDataForm, projectsStore } = AppStore.efh2Store;

  try {
    const response: any = await PRJAPI.UserInputsController.getUserInputsByProjectUuidUsingGET(
      projectsStore.currentProject.projectUuid
    );
    if (response.data.userInputNotes) {
      basicDataForm.note = response.data.userInputNotes;
    }
  } catch (error) {
    console.error(error);
    throw new Error('Unexpected result on updateNote');
  }
}

function validateNote(note) {
  const newNote = note.replace(/[~`!@#$%\^&()_*+=\-\[\]\\;/{}|\\":<>\?]/g, '').substring(0, 1000);
  return newNote;
}
